var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenexAvatar,{attrs:{"color":"#ff95f4"}},[_c('b-icon',{staticClass:"has-text-white",attrs:{"icon":"messages"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }